import React, { useEffect, useState } from 'react'
import { Text, View, TouchableOpacity, Image } from 'react-native'
import DateTimePickerModal from 'react-native-modal-datetime-picker'
import { FormContentsModel, ModelAnswerFromProps } from '../models/StoreDetailModel'
import theme from '../../../../theme'
import styles from './InputDateItemStyles'
import { Feather } from '@expo/vector-icons'
import { updateFormAnswerSchedule } from '../../../../db-sqlite/repositories/schedule.repository'
import { getLanguage } from '../../appBar/context/LocalizationContext'
import { ImageWithZoom } from '../../customUtils/Components/ImageWIthZoom'
import { PATH_ASSETS } from '../../../utils/Constants'
import useImageLoader from '../../../hooks/useImageLoader'
import { Loader } from '../../customUtils/Components/Loader'
import { useBottomSheet } from '../../customUtils/context/BottomSheetContext'
import {
    dateToDisplayString,
    dateToISODateString,
    isoDateStringToDate,
} from '../../../utils/formatDate.function'

interface InputDateItemProps {
    item: FormContentsModel
    form_id: string
    schedule_id: string
    store_id: string
    checkComplete: (option?: ModelAnswerFromProps) => void
}

export const InputDateItem = React.memo(
    ({
        item,
        form_id,
        schedule_id,
        store_id,
        checkComplete,
    }: InputDateItemProps) => {
        const [date, setDate] = useState<Date | null>(null)
        const [isPickerVisible, setPickerVisible] = useState(false)
        const { image, loading, placeholderGeneral } = useImageLoader(
            item.media,
            PATH_ASSETS,
        )
        const [preview, setPreview] = useState(image)

        const { languageFile } = getLanguage()
        const { openBottomSheet } = useBottomSheet()

        useEffect(() => {
            if (item?.old_response?.question_input) {
                setDate(isoDateStringToDate(item.old_response.question_input))
            }
        }, [item?.old_response])

        useEffect(() => {
            setPreview(image)
        }, [image])

        const create_answer = async (selectedDate: Date) => {
            const inputText = dateToISODateString(selectedDate)
            let answerScore = '0'
            if (item.score != null && item.score > 0)
                answerScore = item.score.toString()

            const answer: ModelAnswerFromProps = {
                _id: item._id,
                option_selected_text: [],
                option_selected_id: [],
                question_id: item._id,
                media: '',
                question_text: item.title,
                score: answerScore,
                status: 1,
                date_finish: new Date().toString(),
                date_init: new Date().toString(),
                question_input: inputText,
                field_media: '',
                field_text: '',
                questionScore: item.questionScore,
                type: item.input_type.type,
                ponderar: item.score && item.score > 0,

                question: item.title,
                questionOptionSelected: [],
                questionOptionSelectedText: [],
                questionType: {
                    title: item.input_type.title,
                    type: item.input_type.type,
                    id: item.input_type._id,
                },
                questionPrice: '',
                description: '',
                tag: '',
                questionImage: '',
                questionInput: inputText,
            }

            await updateFormAnswerSchedule({
                newAnswer: answer,
                schedule_id,
                form_id,
                store_id,
                type: 'InputDateItem',
            })
            await checkComplete(answer)
        }

        const handleConfirm = (selectedDate: Date) => {
            setPickerVisible(false)
            setDate(selectedDate)
            create_answer(selectedDate)
        }

        const openBigImage = () => {
            if (image) {
                openBottomSheet(
                    <ImageWithZoom uri={image} contentSeen={() => {}} path={''} />,
                    undefined,
                    undefined,
                    true,
                    true,
                    true,
                )
            }
        }

        return (
            <View style={styles.container}>
                <View style={styles.flexDirectionRow}>
                    {item.media && (
                        <TouchableOpacity onPress={() => openBigImage()}>
                            {loading ? (
                                <View
                                    style={[
                                        styles.image,
                                        {
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                        },
                                    ]}
                                >
                                    <Loader />
                                </View>
                            ) : (
                                <Image
                                    style={styles.image}
                                    source={{ uri: preview }}
                                    onError={() => setPreview(placeholderGeneral)}
                                />
                            )}
                        </TouchableOpacity>
                    )}

                    <View style={styles.containerData}>
                        {item.title && (
                            <Text style={styles.title}>{item.title ?? ''}</Text>
                        )}
                        {item.description && (
                            <Text style={styles.description}>
                                {item.description ?? ''}
                            </Text>
                        )}
                    </View>
                </View>

                <TouchableOpacity
                    style={styles.inputRow}
                    activeOpacity={0.7}
                    onPress={() => setPickerVisible(true)}
                >
                    <Text
                        style={[styles.inputText, !date && styles.placeholderText]}
                    >
                        {date ? dateToDisplayString(date) : 'dd/mm/aaaa'}
                    </Text>
                    <Feather
                        name='calendar'
                        size={20}
                        color={theme.colors.colorPrimary}
                    />
                </TouchableOpacity>

                {isPickerVisible && (
                    <DateTimePickerModal
                        isVisible={isPickerVisible}
                        mode='date'
                        display='spinner'
                        date={date ?? new Date()}
                        onConfirm={handleConfirm}
                        onCancel={() => setPickerVisible(false)}
                        confirmTextIOS={languageFile.confirm}
                        cancelTextIOS={languageFile.cancel}
                        buttonTextColorIOS={theme.colors.colorPrimary}
                        themeVariant='light'
                        isDarkModeEnabled={false}
                    />
                )}
            </View>
        )
    },
)
